var VIDEOASKElements = function (t) {
  "use strict";

  /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
  
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
  
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */
  function e(t, e, s, i) {
    var n,
      r = arguments.length,
      o = r < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, s) : i;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) o = Reflect.decorate(t, e, s, i);else for (var a = t.length - 1; a >= 0; a--) (n = t[a]) && (o = (r < 3 ? n(o) : r > 3 ? n(e, s, o) : n(e, s)) || o);
    return r > 3 && o && Object.defineProperty(e, s, o), o;
    /**
         * @license
         * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
         * This code may only be used under the BSD style license found at
         * http://polymer.github.io/LICENSE.txt
         * The complete set of authors may be found at
         * http://polymer.github.io/AUTHORS.txt
         * The complete set of contributors may be found at
         * http://polymer.github.io/CONTRIBUTORS.txt
         * Code distributed by Google as part of the polymer project is also
         * subject to an additional IP rights grant found at
         * http://polymer.github.io/PATENTS.txt
         */
  }
  const s = new WeakMap(),
    i = t => "function" == typeof t && s.has(t),
    n = void 0 !== window.customElements && void 0 !== window.customElements.polyfillWrapFlushCallback,
    r = function (t, e) {
      let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      for (; e !== s;) {
        const s = e.nextSibling;
        t.removeChild(e), e = s;
      }
    },
    o = {},
    a = {},
    l = `{{lit-${String(Math.random()).slice(2)}}}`,
    d = `\x3c!--${l}--\x3e`,
    h = new RegExp(`${l}|${d}`),
    c = "$lit$";
  class p {
    constructor(t, e) {
      this.parts = [], this.element = e;
      const s = [],
        i = [],
        n = document.createTreeWalker(e.content, 133, null, !1);
      let r = 0,
        o = -1,
        a = 0;
      const {
        strings: d,
        values: {
          length: p
        }
      } = t;
      for (; a < p;) {
        const t = n.nextNode();
        if (null !== t) {
          if (o++, 1 === t.nodeType) {
            if (t.hasAttributes()) {
              const e = t.attributes,
                {
                  length: s
                } = e;
              let i = 0;
              for (let t = 0; t < s; t++) u(e[t].name, c) && i++;
              for (; i-- > 0;) {
                const e = d[a],
                  s = g.exec(e)[2],
                  i = s.toLowerCase() + c,
                  n = t.getAttribute(i);
                t.removeAttribute(i);
                const r = n.split(h);
                this.parts.push({
                  type: "attribute",
                  index: o,
                  name: s,
                  strings: r
                }), a += r.length - 1;
              }
            }
            "TEMPLATE" === t.tagName && (i.push(t), n.currentNode = t.content);
          } else if (3 === t.nodeType) {
            const e = t.data;
            if (e.indexOf(l) >= 0) {
              const i = t.parentNode,
                n = e.split(h),
                r = n.length - 1;
              for (let e = 0; e < r; e++) {
                let s,
                  r = n[e];
                if ("" === r) s = _();else {
                  const t = g.exec(r);
                  null !== t && u(t[2], c) && (r = r.slice(0, t.index) + t[1] + t[2].slice(0, -c.length) + t[3]), s = document.createTextNode(r);
                }
                i.insertBefore(s, t), this.parts.push({
                  type: "node",
                  index: ++o
                });
              }
              "" === n[r] ? (i.insertBefore(_(), t), s.push(t)) : t.data = n[r], a += r;
            }
          } else if (8 === t.nodeType) if (t.data === l) {
            const e = t.parentNode;
            null !== t.previousSibling && o !== r || (o++, e.insertBefore(_(), t)), r = o, this.parts.push({
              type: "node",
              index: o
            }), null === t.nextSibling ? t.data = "" : (s.push(t), o--), a++;
          } else {
            let e = -1;
            for (; -1 !== (e = t.data.indexOf(l, e + 1));) this.parts.push({
              type: "node",
              index: -1
            }), a++;
          }
        } else n.currentNode = i.pop();
      }
      for (const t of s) t.parentNode.removeChild(t);
    }
  }
  const u = (t, e) => {
      const s = t.length - e.length;
      return s >= 0 && t.slice(s) === e;
    },
    m = t => -1 !== t.index,
    _ = () => document.createComment(""),
    g = /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  class y {
    constructor(t, e, s) {
      this.__parts = [], this.template = t, this.processor = e, this.options = s;
    }
    update(t) {
      let e = 0;
      for (const s of this.__parts) void 0 !== s && s.setValue(t[e]), e++;
      for (const t of this.__parts) void 0 !== t && t.commit();
    }
    _clone() {
      const t = n ? this.template.element.content.cloneNode(!0) : document.importNode(this.template.element.content, !0),
        e = [],
        s = this.template.parts,
        i = document.createTreeWalker(t, 133, null, !1);
      let r,
        o = 0,
        a = 0,
        l = i.nextNode();
      for (; o < s.length;) if (r = s[o], m(r)) {
        for (; a < r.index;) a++, "TEMPLATE" === l.nodeName && (e.push(l), i.currentNode = l.content), null === (l = i.nextNode()) && (i.currentNode = e.pop(), l = i.nextNode());
        if ("node" === r.type) {
          const t = this.processor.handleTextExpression(this.options);
          t.insertAfterNode(l.previousSibling), this.__parts.push(t);
        } else this.__parts.push(...this.processor.handleAttributeExpressions(l, r.name, r.strings, this.options));
        o++;
      } else this.__parts.push(void 0), o++;
      return n && (document.adoptNode(t), customElements.upgrade(t)), t;
    }
  }
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  class f {
    constructor(t, e, s, i) {
      this.strings = t, this.values = e, this.type = s, this.processor = i;
    }
    getHTML() {
      const t = this.strings.length - 1;
      let e = "",
        s = !1;
      for (let i = 0; i < t; i++) {
        const t = this.strings[i],
          n = t.lastIndexOf("\x3c!--");
        s = (n > -1 || s) && -1 === t.indexOf("--\x3e", n + 1);
        const r = g.exec(t);
        e += null === r ? t + (s ? l : d) : t.substr(0, r.index) + r[1] + r[2] + c + r[3] + l;
      }
      return e += this.strings[t], e;
    }
    getTemplateElement() {
      const t = document.createElement("template");
      return t.innerHTML = this.getHTML(), t;
    }
  }
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  const v = t => null === t || !("object" == typeof t || "function" == typeof t),
    S = t => Array.isArray(t) || !(!t || !t[Symbol.iterator]);
  class w {
    constructor(t, e, s) {
      this.dirty = !0, this.element = t, this.name = e, this.strings = s, this.parts = [];
      for (let t = 0; t < s.length - 1; t++) this.parts[t] = this._createPart();
    }
    _createPart() {
      return new b(this);
    }
    _getValue() {
      const t = this.strings,
        e = t.length - 1;
      let s = "";
      for (let i = 0; i < e; i++) {
        s += t[i];
        const e = this.parts[i];
        if (void 0 !== e) {
          const t = e.value;
          if (v(t) || !S(t)) s += "string" == typeof t ? t : String(t);else for (const e of t) s += "string" == typeof e ? e : String(e);
        }
      }
      return s += t[e], s;
    }
    commit() {
      this.dirty && (this.dirty = !1, this.element.setAttribute(this.name, this._getValue()));
    }
  }
  class b {
    constructor(t) {
      this.value = void 0, this.committer = t;
    }
    setValue(t) {
      t === o || v(t) && t === this.value || (this.value = t, i(t) || (this.committer.dirty = !0));
    }
    commit() {
      for (; i(this.value);) {
        const t = this.value;
        this.value = o, t(this);
      }
      this.value !== o && this.committer.commit();
    }
  }
  class x {
    constructor(t) {
      this.value = void 0, this.__pendingValue = void 0, this.options = t;
    }
    appendInto(t) {
      this.startNode = t.appendChild(_()), this.endNode = t.appendChild(_());
    }
    insertAfterNode(t) {
      this.startNode = t, this.endNode = t.nextSibling;
    }
    appendIntoPart(t) {
      t.__insert(this.startNode = _()), t.__insert(this.endNode = _());
    }
    insertAfterPart(t) {
      t.__insert(this.startNode = _()), this.endNode = t.endNode, t.endNode = this.startNode;
    }
    setValue(t) {
      this.__pendingValue = t;
    }
    commit() {
      for (; i(this.__pendingValue);) {
        const t = this.__pendingValue;
        this.__pendingValue = o, t(this);
      }
      const t = this.__pendingValue;
      t !== o && (v(t) ? t !== this.value && this.__commitText(t) : t instanceof f ? this.__commitTemplateResult(t) : t instanceof Node ? this.__commitNode(t) : S(t) ? this.__commitIterable(t) : t === a ? (this.value = a, this.clear()) : this.__commitText(t));
    }
    __insert(t) {
      this.endNode.parentNode.insertBefore(t, this.endNode);
    }
    __commitNode(t) {
      this.value !== t && (this.clear(), this.__insert(t), this.value = t);
    }
    __commitText(t) {
      const e = this.startNode.nextSibling;
      t = null == t ? "" : t, e === this.endNode.previousSibling && 3 === e.nodeType ? e.data = t : this.__commitNode(document.createTextNode("string" == typeof t ? t : String(t))), this.value = t;
    }
    __commitTemplateResult(t) {
      const e = this.options.templateFactory(t);
      if (this.value instanceof y && this.value.template === e) this.value.update(t.values);else {
        const s = new y(e, t.processor, this.options),
          i = s._clone();
        s.update(t.values), this.__commitNode(i), this.value = s;
      }
    }
    __commitIterable(t) {
      Array.isArray(this.value) || (this.value = [], this.clear());
      const e = this.value;
      let s,
        i = 0;
      for (const n of t) s = e[i], void 0 === s && (s = new x(this.options), e.push(s), 0 === i ? s.appendIntoPart(this) : s.insertAfterPart(e[i - 1])), s.setValue(n), s.commit(), i++;
      i < e.length && (e.length = i, this.clear(s && s.endNode));
    }
    clear() {
      let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.startNode;
      r(this.startNode.parentNode, t.nextSibling, this.endNode);
    }
  }
  class P {
    constructor(t, e, s) {
      if (this.value = void 0, this.__pendingValue = void 0, 2 !== s.length || "" !== s[0] || "" !== s[1]) throw new Error("Boolean attributes can only contain a single expression");
      this.element = t, this.name = e, this.strings = s;
    }
    setValue(t) {
      this.__pendingValue = t;
    }
    commit() {
      for (; i(this.__pendingValue);) {
        const t = this.__pendingValue;
        this.__pendingValue = o, t(this);
      }
      if (this.__pendingValue === o) return;
      const t = !!this.__pendingValue;
      this.value !== t && (t ? this.element.setAttribute(this.name, "") : this.element.removeAttribute(this.name), this.value = t), this.__pendingValue = o;
    }
  }
  class C extends w {
    constructor(t, e, s) {
      super(t, e, s), this.single = 2 === s.length && "" === s[0] && "" === s[1];
    }
    _createPart() {
      return new A(this);
    }
    _getValue() {
      return this.single ? this.parts[0].value : super._getValue();
    }
    commit() {
      this.dirty && (this.dirty = !1, this.element[this.name] = this._getValue());
    }
  }
  class A extends b {}
  let N = !1;
  try {
    const t = {
      get capture() {
        return N = !0, !1;
      }
    };
    window.addEventListener("test", t, t), window.removeEventListener("test", t, t);
  } catch (t) {}
  class E {
    constructor(t, e, s) {
      this.value = void 0, this.__pendingValue = void 0, this.element = t, this.eventName = e, this.eventContext = s, this.__boundHandleEvent = t => this.handleEvent(t);
    }
    setValue(t) {
      this.__pendingValue = t;
    }
    commit() {
      for (; i(this.__pendingValue);) {
        const t = this.__pendingValue;
        this.__pendingValue = o, t(this);
      }
      if (this.__pendingValue === o) return;
      const t = this.__pendingValue,
        e = this.value,
        s = null == t || null != e && (t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive),
        n = null != t && (null == e || s);
      s && this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options), n && (this.__options = k(t), this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options)), this.value = t, this.__pendingValue = o;
    }
    handleEvent(t) {
      "function" == typeof this.value ? this.value.call(this.eventContext || this.element, t) : this.value.handleEvent(t);
    }
  }
  const k = t => t && (N ? {
    capture: t.capture,
    passive: t.passive,
    once: t.once
  } : t.capture);
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  const V = new class {
    handleAttributeExpressions(t, e, s, i) {
      const n = e[0];
      if ("." === n) {
        return new C(t, e.slice(1), s).parts;
      }
      return "@" === n ? [new E(t, e.slice(1), i.eventContext)] : "?" === n ? [new P(t, e.slice(1), s)] : new w(t, e, s).parts;
    }
    handleTextExpression(t) {
      return new x(t);
    }
  }();
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  function T(t) {
    let e = O.get(t.type);
    void 0 === e && (e = {
      stringsArray: new WeakMap(),
      keyString: new Map()
    }, O.set(t.type, e));
    let s = e.stringsArray.get(t.strings);
    if (void 0 !== s) return s;
    const i = t.strings.join(l);
    return s = e.keyString.get(i), void 0 === s && (s = new p(t, t.getTemplateElement()), e.keyString.set(i, s)), e.stringsArray.set(t.strings, s), s;
  }
  const O = new Map(),
    R = new WeakMap();
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  (window.litHtmlVersions || (window.litHtmlVersions = [])).push("1.0.0");
  const j = function (t) {
      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }
      return new f(t, e, "html", V);
    },
    W = 133;
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  function U(t, e) {
    const {
        element: {
          content: s
        },
        parts: i
      } = t,
      n = document.createTreeWalker(s, W, null, !1);
    let r = I(i),
      o = i[r],
      a = -1,
      l = 0;
    const d = [];
    let h = null;
    for (; n.nextNode();) {
      a++;
      const t = n.currentNode;
      for (t.previousSibling === h && (h = null), e.has(t) && (d.push(t), null === h && (h = t)), null !== h && l++; void 0 !== o && o.index === a;) o.index = null !== h ? -1 : o.index - l, r = I(i, r), o = i[r];
    }
    d.forEach(t => t.parentNode.removeChild(t));
  }
  const M = t => {
      let e = 11 === t.nodeType ? 0 : 1;
      const s = document.createTreeWalker(t, W, null, !1);
      for (; s.nextNode();) e++;
      return e;
    },
    I = function (t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      for (let s = e + 1; s < t.length; s++) {
        const e = t[s];
        if (m(e)) return s;
      }
      return -1;
    };
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  const z = (t, e) => `${t}--${e}`;
  let q = !0;
  void 0 === window.ShadyCSS ? q = !1 : void 0 === window.ShadyCSS.prepareTemplateDom && (console.warn("Incompatible ShadyCSS version detected. Please update to at least @webcomponents/webcomponentsjs@2.0.2 and @webcomponents/shadycss@1.3.1."), q = !1);
  const L = t => e => {
      const s = z(e.type, t);
      let i = O.get(s);
      void 0 === i && (i = {
        stringsArray: new WeakMap(),
        keyString: new Map()
      }, O.set(s, i));
      let n = i.stringsArray.get(e.strings);
      if (void 0 !== n) return n;
      const r = e.strings.join(l);
      if (n = i.keyString.get(r), void 0 === n) {
        const s = e.getTemplateElement();
        q && window.ShadyCSS.prepareTemplateDom(s, t), n = new p(e, s), i.keyString.set(r, n);
      }
      return i.stringsArray.set(e.strings, n), n;
    },
    $ = ["html", "svg"],
    H = new Set(),
    F = (t, e, s) => {
      H.add(s);
      const i = t.querySelectorAll("style"),
        {
          length: n
        } = i;
      if (0 === n) return void window.ShadyCSS.prepareTemplateStyles(e.element, s);
      const r = document.createElement("style");
      for (let t = 0; t < n; t++) {
        const e = i[t];
        e.parentNode.removeChild(e), r.textContent += e.textContent;
      }
      (t => {
        $.forEach(e => {
          const s = O.get(z(e, t));
          void 0 !== s && s.keyString.forEach(t => {
            const {
                element: {
                  content: e
                }
              } = t,
              s = new Set();
            Array.from(e.querySelectorAll("style")).forEach(t => {
              s.add(t);
            }), U(t, s);
          });
        });
      })(s);
      const o = e.element.content;
      !function (t, e) {
        let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        const {
          element: {
            content: i
          },
          parts: n
        } = t;
        if (null == s) return void i.appendChild(e);
        const r = document.createTreeWalker(i, W, null, !1);
        let o = I(n),
          a = 0,
          l = -1;
        for (; r.nextNode();) {
          for (l++, r.currentNode === s && (a = M(e), s.parentNode.insertBefore(e, s)); -1 !== o && n[o].index === l;) {
            if (a > 0) {
              for (; -1 !== o;) n[o].index += a, o = I(n, o);
              return;
            }
            o = I(n, o);
          }
        }
      }(e, r, o.firstChild), window.ShadyCSS.prepareTemplateStyles(e.element, s);
      const a = o.querySelector("style");
      if (window.ShadyCSS.nativeShadow && null !== a) t.insertBefore(a.cloneNode(!0), t.firstChild);else {
        o.insertBefore(r, o.firstChild);
        const t = new Set();
        t.add(r), U(e, t);
      }
    };
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  window.JSCompiler_renameProperty = (t, e) => t;
  const B = {
      toAttribute(t, e) {
        switch (e) {
          case Boolean:
            return t ? "" : null;
          case Object:
          case Array:
            return null == t ? t : JSON.stringify(t);
        }
        return t;
      },
      fromAttribute(t, e) {
        switch (e) {
          case Boolean:
            return null !== t;
          case Number:
            return null === t ? null : Number(t);
          case Object:
          case Array:
            return JSON.parse(t);
        }
        return t;
      }
    },
    J = (t, e) => e !== t && (e == e || t == t),
    D = {
      attribute: !0,
      type: String,
      converter: B,
      reflect: !1,
      hasChanged: J
    },
    K = Promise.resolve(!0),
    G = 1,
    Q = 4,
    X = 8,
    Y = 16,
    Z = 32;
  class tt extends HTMLElement {
    constructor() {
      super(), this._updateState = 0, this._instanceProperties = void 0, this._updatePromise = K, this._hasConnectedResolver = void 0, this._changedProperties = new Map(), this._reflectingProperties = void 0, this.initialize();
    }
    static get observedAttributes() {
      this.finalize();
      const t = [];
      return this._classProperties.forEach((e, s) => {
        const i = this._attributeNameForProperty(s, e);
        void 0 !== i && (this._attributeToPropertyMap.set(i, s), t.push(i));
      }), t;
    }
    static _ensureClassProperties() {
      if (!this.hasOwnProperty(JSCompiler_renameProperty("_classProperties", this))) {
        this._classProperties = new Map();
        const t = Object.getPrototypeOf(this)._classProperties;
        void 0 !== t && t.forEach((t, e) => this._classProperties.set(e, t));
      }
    }
    static createProperty(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : D;
      if (this._ensureClassProperties(), this._classProperties.set(t, e), e.noAccessor || this.prototype.hasOwnProperty(t)) return;
      const s = "symbol" == typeof t ? Symbol() : `__${t}`;
      Object.defineProperty(this.prototype, t, {
        get() {
          return this[s];
        },
        set(e) {
          const i = this[t];
          this[s] = e, this._requestUpdate(t, i);
        },
        configurable: !0,
        enumerable: !0
      });
    }
    static finalize() {
      if (this.hasOwnProperty(JSCompiler_renameProperty("finalized", this)) && this.finalized) return;
      const t = Object.getPrototypeOf(this);
      if ("function" == typeof t.finalize && t.finalize(), this.finalized = !0, this._ensureClassProperties(), this._attributeToPropertyMap = new Map(), this.hasOwnProperty(JSCompiler_renameProperty("properties", this))) {
        const t = this.properties,
          e = [...Object.getOwnPropertyNames(t), ...("function" == typeof Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t) : [])];
        for (const s of e) this.createProperty(s, t[s]);
      }
    }
    static _attributeNameForProperty(t, e) {
      const s = e.attribute;
      return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    static _valueHasChanged(t, e) {
      let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : J;
      return s(t, e);
    }
    static _propertyValueFromAttribute(t, e) {
      const s = e.type,
        i = e.converter || B,
        n = "function" == typeof i ? i : i.fromAttribute;
      return n ? n(t, s) : t;
    }
    static _propertyValueToAttribute(t, e) {
      if (void 0 === e.reflect) return;
      const s = e.type,
        i = e.converter;
      return (i && i.toAttribute || B.toAttribute)(t, s);
    }
    initialize() {
      this._saveInstanceProperties(), this._requestUpdate();
    }
    _saveInstanceProperties() {
      this.constructor._classProperties.forEach((t, e) => {
        if (this.hasOwnProperty(e)) {
          const t = this[e];
          delete this[e], this._instanceProperties || (this._instanceProperties = new Map()), this._instanceProperties.set(e, t);
        }
      });
    }
    _applyInstanceProperties() {
      this._instanceProperties.forEach((t, e) => this[e] = t), this._instanceProperties = void 0;
    }
    connectedCallback() {
      this._updateState = this._updateState | Z, this._hasConnectedResolver && (this._hasConnectedResolver(), this._hasConnectedResolver = void 0);
    }
    disconnectedCallback() {}
    attributeChangedCallback(t, e, s) {
      e !== s && this._attributeToProperty(t, s);
    }
    _propertyToAttribute(t, e) {
      let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : D;
      const i = this.constructor,
        n = i._attributeNameForProperty(t, s);
      if (void 0 !== n) {
        const t = i._propertyValueToAttribute(e, s);
        if (void 0 === t) return;
        this._updateState = this._updateState | X, null == t ? this.removeAttribute(n) : this.setAttribute(n, t), this._updateState = this._updateState & ~X;
      }
    }
    _attributeToProperty(t, e) {
      if (this._updateState & X) return;
      const s = this.constructor,
        i = s._attributeToPropertyMap.get(t);
      if (void 0 !== i) {
        const t = s._classProperties.get(i) || D;
        this._updateState = this._updateState | Y, this[i] = s._propertyValueFromAttribute(e, t), this._updateState = this._updateState & ~Y;
      }
    }
    _requestUpdate(t, e) {
      let s = !0;
      if (void 0 !== t) {
        const i = this.constructor,
          n = i._classProperties.get(t) || D;
        i._valueHasChanged(this[t], e, n.hasChanged) ? (this._changedProperties.has(t) || this._changedProperties.set(t, e), !0 !== n.reflect || this._updateState & Y || (void 0 === this._reflectingProperties && (this._reflectingProperties = new Map()), this._reflectingProperties.set(t, n))) : s = !1;
      }
      !this._hasRequestedUpdate && s && this._enqueueUpdate();
    }
    requestUpdate(t, e) {
      return this._requestUpdate(t, e), this.updateComplete;
    }
    async _enqueueUpdate() {
      let t, e;
      this._updateState = this._updateState | Q;
      const s = this._updatePromise;
      this._updatePromise = new Promise((s, i) => {
        t = s, e = i;
      });
      try {
        await s;
      } catch (t) {}
      this._hasConnected || (await new Promise(t => this._hasConnectedResolver = t));
      try {
        const t = this.performUpdate();
        null != t && (await t);
      } catch (t) {
        e(t);
      }
      t(!this._hasRequestedUpdate);
    }
    get _hasConnected() {
      return this._updateState & Z;
    }
    get _hasRequestedUpdate() {
      return this._updateState & Q;
    }
    get hasUpdated() {
      return this._updateState & G;
    }
    performUpdate() {
      this._instanceProperties && this._applyInstanceProperties();
      let t = !1;
      const e = this._changedProperties;
      try {
        t = this.shouldUpdate(e), t && this.update(e);
      } catch (e) {
        throw t = !1, e;
      } finally {
        this._markUpdated();
      }
      t && (this._updateState & G || (this._updateState = this._updateState | G, this.firstUpdated(e)), this.updated(e));
    }
    _markUpdated() {
      this._changedProperties = new Map(), this._updateState = this._updateState & ~Q;
    }
    get updateComplete() {
      return this._updatePromise;
    }
    shouldUpdate(t) {
      return !0;
    }
    update(t) {
      void 0 !== this._reflectingProperties && this._reflectingProperties.size > 0 && (this._reflectingProperties.forEach((t, e) => this._propertyToAttribute(e, this[e], t)), this._reflectingProperties = void 0);
    }
    updated(t) {}
    firstUpdated(t) {}
  }
  tt.finalized = !0;
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  const et = t => e => "function" == typeof e ? ((t, e) => (window.customElements.define(t, e), e))(t, e) : ((t, e) => {
      const {
        kind: s,
        elements: i
      } = e;
      return {
        kind: s,
        elements: i,
        finisher(e) {
          window.customElements.define(t, e);
        }
      };
    })(t, e),
    st = (t, e) => "method" !== e.kind || !e.descriptor || "value" in e.descriptor ? {
      kind: "field",
      key: Symbol(),
      placement: "own",
      descriptor: {},
      initializer() {
        "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
      },
      finisher(s) {
        s.createProperty(e.key, t);
      }
    } : Object.assign({}, e, {
      finisher(s) {
        s.createProperty(e.key, t);
      }
    }),
    it = (t, e, s) => {
      e.constructor.createProperty(s, t);
    };
  function nt(t) {
    return (e, s) => void 0 !== s ? it(t, e, s) : st(t, e);
  }
  /**
      @license
      Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
      This code may only be used under the BSD style license found at
      http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
      http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
      found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
      part of the polymer project is also subject to an additional IP rights grant
      found at http://polymer.github.io/PATENTS.txt
      */
  const rt = "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
    ot = Symbol();
  class at {
    constructor(t, e) {
      if (e !== ot) throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
      this.cssText = t;
    }
    get styleSheet() {
      return void 0 === this._styleSheet && (rt ? (this._styleSheet = new CSSStyleSheet(), this._styleSheet.replaceSync(this.cssText)) : this._styleSheet = null), this._styleSheet;
    }
    toString() {
      return this.cssText;
    }
  }
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  (window.litElementVersions || (window.litElementVersions = [])).push("2.2.0");
  const lt = t => t.flat ? t.flat(1 / 0) : function t(e) {
    let s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    for (let i = 0, n = e.length; i < n; i++) {
      const n = e[i];
      Array.isArray(n) ? t(n, s) : s.push(n);
    }
    return s;
  }(t);
  class dt extends tt {
    static finalize() {
      super.finalize(), this._styles = this.hasOwnProperty(JSCompiler_renameProperty("styles", this)) ? this._getUniqueStyles() : this._styles || [];
    }
    static _getUniqueStyles() {
      const t = this.styles,
        e = [];
      if (Array.isArray(t)) {
        lt(t).reduceRight((t, e) => (t.add(e), t), new Set()).forEach(t => e.unshift(t));
      } else t && e.push(t);
      return e;
    }
    initialize() {
      super.initialize(), this.renderRoot = this.createRenderRoot(), window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot && this.adoptStyles();
    }
    createRenderRoot() {
      return this.attachShadow({
        mode: "open"
      });
    }
    adoptStyles() {
      const t = this.constructor._styles;
      0 !== t.length && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow ? rt ? this.renderRoot.adoptedStyleSheets = t.map(t => t.styleSheet) : this._needsShimAdoptedStyleSheets = !0 : window.ShadyCSS.ScopingShim.prepareAdoptedCssText(t.map(t => t.cssText), this.localName));
    }
    connectedCallback() {
      super.connectedCallback(), this.hasUpdated && void 0 !== window.ShadyCSS && window.ShadyCSS.styleElement(this);
    }
    update(t) {
      super.update(t);
      const e = this.render();
      e instanceof f && this.constructor.render(e, this.renderRoot, {
        scopeName: this.localName,
        eventContext: this
      }), this._needsShimAdoptedStyleSheets && (this._needsShimAdoptedStyleSheets = !1, this.constructor._styles.forEach(t => {
        const e = document.createElement("style");
        e.textContent = t.cssText, this.renderRoot.appendChild(e);
      }));
    }
    render() {}
  }
  dt.finalized = !0, dt.render = (t, e, s) => {
    const i = s.scopeName,
      n = R.has(e),
      o = q && 11 === e.nodeType && !!e.host && t instanceof f,
      a = o && !H.has(i),
      l = a ? document.createDocumentFragment() : e;
    if (((t, e, s) => {
      let i = R.get(e);
      void 0 === i && (r(e, e.firstChild), R.set(e, i = new x(Object.assign({
        templateFactory: T
      }, s))), i.appendInto(e)), i.setValue(t), i.commit();
    })(t, l, Object.assign({
      templateFactory: L(i)
    }, s)), a) {
      const t = R.get(l);
      R.delete(l), t.value instanceof y && F(l, t.value.template, i), r(e, e.firstChild), e.appendChild(l), R.set(e, t);
    }
    !n && o && window.ShadyCSS.styleElement(e.host);
  };
  const ht = t => (t => new at(String(t), ot))(void 0 + t),
    ct = t => /^[+-]?[0-9]+.?([0-9]+)?(%|cm|em|ex|in|mm|pc|pt|px|vh|vw)$/.test(t),
    pt = () => j`<p>Invalid VideoAsk URL</p>`,
    ut = t => /^(http|https):\/\/(.+.)?videoask.(it|com)\/(\w){9}($|\?.*$)/.test(t);
  t.VideoAskEmbed = class extends dt {
    render() {
      return this.updateComplete.then(() => {
        this.dispatchEvent(new CustomEvent("render", {
          detail: this.shadowRoot.querySelector("iframe")
        }));
      }), ut(this.url) ? j`
        <div style="
          height: ${ct(this.height) ? this.height : "500px"};
          width: ${ct(this.width) ? this.width : "350px"};
        ">
          <iframe
            src="${this.url}"
            allow="camera; microphone; autoplay; encrypted-media;"
          >
          </iframe>
        </div>
      ` : pt();
    }
    get element() {
      return this.shadowRoot.querySelector("iframe");
    }
    static get styles() {
      return ht(":host {\n  display: block; }\n  :host div, :host iframe {\n    height: 100%;\n    width: 100%;\n    border: none; }\n");
    }
  }, e([nt({
    type: String
  })], t.VideoAskEmbed.prototype, "url", void 0), e([nt({
    type: String
  })], t.VideoAskEmbed.prototype, "height", void 0), e([nt({
    type: String
  })], t.VideoAskEmbed.prototype, "width", void 0), t.VideoAskEmbed = e([et("videoask-embed")], t.VideoAskEmbed);
  const mt = ["url", "widgetType", "text", "backgroundColor", "position", "customEmoji"];
  function _t() {
    let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "VideoThumbnailLarge";
    switch (t = t.toLowerCase()) {
      case "videothumbnailsmall":
      case "small":
        return "VideoThumbnailSmall";
      case "customemoji":
      case "emoji":
        return "CustomEmoji";
      default:
        return "VideoThumbnailLarge";
    }
  }
  return t.VideoAskWidget = class extends dt {
    constructor() {
      super(), this.widgetType = "VideoThumbnailLarge", this.text = "Talk to me", this.backgroundColor = "#4E2AB9", this.position = "bottom-right", this.customEmoji = "👋", this._embedInHead = !1, this._rendering = !1;
      const t = "https://www.videoask.com/embed/embed.js";
      if (this._embedInHead = !!document.querySelector(`script[src='${t}']`), !this._embedInHead) {
        const e = document.createElement("script");
        e.setAttribute("src", t), document.getElementsByTagName("head")[0].appendChild(e), this._embedInHead = !0;
      }
      const e = setInterval(() => {
        window.videoask && (this._videoask = window.videoask, this._renderWidget(), clearInterval(e));
      }, 100);
    }
    render() {
      return ut(this.url) ? j`` : pt();
    }
    updated(t) {
      const e = [...mt, "url"];
      for (let s of e) if (t.has(s) && t.get(s) !== this[s]) return this._renderWidget();
    }
    disconnectedCallback() {
      super.disconnectedCallback(), this._destroyWidget();
    }
    get element() {
      return this._element;
    }
    static get styles() {
      return ht(":host {\n  display: block; }\n");
    }
    _renderWidget() {
      if (!ut(this.url) || !this._videoask || this._rendering) return;
      this._rendering = !0, this._destroyWidget();
      const t = {};
      mt.forEach(e => {
        if (this[e]) {
          let s = this[e];
          if ("position" === e && (s = function () {
            let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "bottom-right";
            switch (t = t.toLowerCase()) {
              case "bottom-left":
              case "left":
                return "bottom-left";
              default:
                return "bottom-right";
            }
          }(s)), "widgetType" === e && (s = _t(s)), "emoji" === e && "CustomEmoji" !== _t(s)) return;
          t[e] = s;
        }
      }), this._videoask.loadEmbed({
        kind: "widget",
        url: this.url,
        options: t
      }).then(t => {
        this._element = t, this._rendering = !1, this.dispatchEvent(new CustomEvent("render", {
          detail: t
        }));
      });
    }
    _destroyWidget() {
      this._element && (this._element.remove(), this._element = null);
    }
  }, e([nt({
    type: String
  })], t.VideoAskWidget.prototype, "url", void 0), e([nt({
    type: String,
    attribute: "type"
  })], t.VideoAskWidget.prototype, "widgetType", void 0), e([nt({
    type: String
  })], t.VideoAskWidget.prototype, "text", void 0), e([nt({
    type: String,
    attribute: "color"
  })], t.VideoAskWidget.prototype, "backgroundColor", void 0), e([nt({
    type: String
  })], t.VideoAskWidget.prototype, "position", void 0), e([nt({
    type: String,
    attribute: "emoji"
  })], t.VideoAskWidget.prototype, "customEmoji", void 0), t.VideoAskWidget = e([et("videoask-widget")], t.VideoAskWidget), t;
}({});